import React, { useState } from "react";
import CustomInput from "./CustomInput";
import ButtomSave from "./ButtomSave";
import { useStore } from "../lib/store";
import axios from "axios";
import { toast } from "sonner";

import PaymentStatus from "./PaymanetStatus";
import { AmplitudeLog } from "../lib/amplitude";
import { isTablet } from 'react-device-detect';
import { isToday } from "../lib/utils";
import { RadioGroup } from "../components-shadcn/radio-group";
import { Label } from "../components-shadcn/label";
import { ReactComponent as RadioButtomIcon } from '../assets/radiobutton.svg';
import { ReactComponent as RadioButtomIconDisable } from '../assets/radiobuttom_disable.svg';

type DocumentType = "CPF" | "CNPJ";

type IconKey = "error" | "success" | "processing";

interface TypePaymentStatus {
  open: boolean;
  icon: IconKey;
  title: string;
  legend: string;
}

interface Props {
  invoice?: string;
  onClose?: () => void;
  name_button: string;
  checkout?: boolean;
  entrada?: boolean;
  produto?: any;
}

const FormCreditCard: React.FC<Props> = ({ invoice, name_button, onClose, checkout, entrada, produto }) => {
  const { id_superlogica } = useStore();
  const { id_hubspot } = useStore();
  const { set_sync_invoices } = useStore();
  const { credit_card } = useStore();
  const { set_sync_checkout } = useStore();
  const { user } = useStore();

  const [cardNumber, setCardNumber] = useState("");
  const [errorCardNumber, setErrorCardNumber] = useState("");

  const [cardName, setCardName] = useState("");
  const [errorCardName, setErrorCardName] = useState("");

  const [documentType, setDocumentType] = useState<DocumentType>("CPF");

  const [cardCPF, setCardCPF] = useState("");
  const [errorCardCPF, setErrorCardCPF] = useState("");

  const [cardCNPJ, setCardCNPJ] = useState("");
  const [errorCardCNPJ, setErrorCardCNPJ] = useState("");

  const [cardData, setCardData] = useState("");
  const [errorCardData, setErrorCardData] = useState("");

  const [cardCVV, setCardCVV] = useState("");
  const [errorCardCVV, setErrorCardCVV] = useState("");

  const [status_payment, set_status_payment] = useState<TypePaymentStatus>({
    open: false,
    icon: "processing",
    title: "",
    legend: "",
  });

  const [loading, set_loading] = useState(false);

  const HandleInvoiceMethod = () => {
    if(isToday(entrada ? produto.vencimento_fatura_entrada : produto.vencimento_fatura)){
      PayInvoice();
    }else{
      AutorizePayment();
    }
  }

  const AutorizePayment = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/autorized_payment",
        {
          invoice: invoice
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_loading(false);
        set_sync_checkout(true);
        if(onClose) onClose();
      } else {
        set_loading(false);
        toast("Erro ao registrar fatura: ", {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      }
    } catch (erro: any) {
      set_loading(false);
      toast("Erro ao registrar fatura: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
    }
  };

  const PayInvoice = async () => {
    set_loading(true);
    try {
      const resposta = await axios.post(
        "https://n8n.kinology.com.br/webhook/pay_invoice",
        {
          invoice: invoice ? invoice.toString() : undefined,
          checkout: checkout ? true : false,
        },
        {
          headers: {
            "Content-Type": "application/json",
            n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
          },
        }
      );

      if (resposta.data.status_code === 200) {
        set_status_payment({
          icon: "success",
          title: "Pagamento aprovado!",
          legend:
            "O pagamento foi aprovado com sucesso! Enviaremos a NF-e para o e-mail financeiro cadastrado.",
          open: true,
        });
        set_loading(false);
        set_sync_invoices(true);
        set_sync_checkout(true);
        if(onClose) onClose();
      } else {
        set_status_payment({
          icon: "error",
          title: "Falha no pagamento",
          legend: resposta.data.msg,
          open: true,
        });
        set_loading(false);
      }
    } catch (erro: any) {
      toast("Erro ao pagar fatura: " + erro.message, {
        action: {
          label: "X",
          onClick: () => console.log("Undo"),
        },
        className: "!bg-red-dark !text-white-primary",
      });
      set_loading(false);
    }
  };

  const verifyError = () => {
    const documentValue = documentType === "CPF" ? cardCPF : cardCNPJ;
    const documentError = documentType === "CPF" ? errorCardCPF : errorCardCNPJ;
    if (
      cardNumber === "" ||
      cardName === "" ||
      documentValue === "" ||
      documentError !== "" ||
      cardData === "" ||
      cardCVV === ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const SetAmplitudeTag = () => {
    let tag = "";
    if (invoice) {
      tag = "Pagar_cartao_pagamento";
    } else {
      if (credit_card) {
        tag = "Fim_atualizar_cartao_pagamento";
      } else {
        tag = "Fim_cadastro_cartao_pagamento";
      }
    }
    AmplitudeLog(tag, { user_id: user });
  };

  const cadastrarCartao = async () => {
    SetAmplitudeTag();
    const documentValue = documentType === "CPF" ? cardCPF : cardCNPJ;
    const documentError = documentType === "CPF" ? errorCardCPF : errorCardCNPJ;
    if (
      errorCardNumber === "" &&
      errorCardName === "" &&
      errorCardData === "" &&
      errorCardCVV === "" &&
      documentError === "" &&
      cardNumber !== "" &&
      cardName !== "" &&
      documentValue !== "" &&
      cardData !== "" &&
      cardCVV !== ""
    ) {
      try {
        set_loading(true);
        const resposta = await axios.post(
          "https://n8n.kinology.com.br/webhook/change_credit_card",
          {
            id_superlogica: id_superlogica,
            id_hub: id_hubspot,
            card: {
              number: cardNumber,
              cpf_cnpj: documentValue,
              cvv: cardCVV,
              first_name: cardName.split(" ")[0],
              last_name: cardName.split(" ").slice(1).join(" "),
              month: cardData.substring(0, 2),
              year: "20" + cardData.slice(-2),
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
              n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
            },
          }
        );

        if (resposta.data.status_code === 200) {
          toast(resposta.data.msg, {
            action: {
              label: "✓",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-green-dark !text-white-primary",
          });
          set_sync_invoices(true);
          if (invoice) {
            HandleInvoiceMethod();
          }else{
            set_sync_checkout(true);
            if(onClose) onClose();
            set_loading(true);
          }
        } else {
          toast(resposta.data.msg, {
            action: {
              label: "x",
              onClick: () => console.log("Undo"),
            },
            className: "!bg-red-dark !text-white-primary",
          });
          set_loading(false);
        }
      } catch (erro: any) {
        toast("Erro ao cadastrar cartão: " + erro.message, {
          action: {
            label: "X",
            onClick: () => console.log("Undo"),
          },
          className: "!bg-red-dark !text-white-primary",
        });
        set_loading(false);
      }
    }
  };

  return (
    <div className="pb-[2rem]">
      <p className="text-gray-dark text-[1.04rem] my-[1.8rem] font-[700] text-center">
        {credit_card?.num_card === "" ? "Cadastrar cartão" : "Atualizar cartão"}
      </p>
      <div className="flex flex-col gap-[1.5rem]">
        <CustomInput
          icon="card"
          title="Número do cartão"
          placeholder="0000 0000 0000 0000"
          type="card_number"
          value={cardNumber}
          onChange={setCardNumber}
          error={errorCardNumber}
          onError={setErrorCardNumber}
        />
        <div>
          <Label className="text-[0.8rem] font-[600] text-blue-primary">Tipo de documento</Label>
          <RadioGroup className="flex flex-row gap-x-[1.5rem] mt-[0.5rem]">
            <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setDocumentType("CPF")}>
              {documentType === "CPF" ? <RadioButtomIcon /> : <RadioButtomIconDisable />}
              <Label htmlFor="document-type-cpf">CPF</Label>
            </div>
            <div className="flex items-center space-x-2 cursor-pointer" onClick={() => setDocumentType("CNPJ")}>
              {documentType === "CNPJ" ? <RadioButtomIcon /> : <RadioButtomIconDisable />}
              <Label htmlFor="document-type-cnpj">CNPJ</Label>
            </div>
          </RadioGroup>
        </div>
        <div className={isTablet ? "flex flex-row gap-5" : "flex flex-col gap-[1.5rem]"}>
          {documentType === "CPF" ? (
            <CustomInput
              icon="name"
              title="CPF do titular"
              placeholder="000.000.000-00"
              type="card_cpf"
              value={cardCPF}
              onChange={setCardCPF}
              error={errorCardCPF}
              onError={setErrorCardCPF}
            />
          ) : (
            <CustomInput
              icon="none"
              title="CNPJ"
              placeholder="00.000.000/0000-00"
              type="cnpj"
              value={cardCNPJ}
              onChange={setCardCNPJ}
              error={errorCardCNPJ}
              onError={setErrorCardCNPJ}
            />
          )}
          <CustomInput
            icon="name"
            title="Nome impresso no cartão"
            placeholder="Nome"
            type="card_name"
            value={cardName}
            onChange={setCardName}
            error={errorCardName}
            onError={setErrorCardName}
          />
        </div>
        <div className="flex flex-row gap-[1.5rem]">
          <CustomInput
            icon="calendar"
            title="Data de expiração"
            placeholder="00/00"
            type="card_data"
            value={cardData}
            onChange={setCardData}
            error={errorCardData}
            onError={setErrorCardData}
          />
          <CustomInput
            icon="card"
            title="CVV"
            placeholder="000"
            type="card_cvv"
            value={cardCVV}
            onChange={setCardCVV}
            error={errorCardCVV}
            onError={setErrorCardCVV}
          />
        </div>
      </div>
      <p className="text-[0.6rem] mt-[0.8rem]">
        <strong>Atenção: </strong>fazemos uma cobrança de pequeno valor que será
        estornado.
      </p>
      <p className="text-[0.6rem] mt-[0.8rem] mb-[0.8rem]">
        Ao clicar em “Pagar Fatura”, você autoriza a cobrança no cartão informado. O valor da assinatura está sujeito a reajuste.
      </p>
      <ButtomSave
        theme={invoice ? "mediumgreen" : "blue"}
        icon="none"
        onClick={!verifyError() ? cadastrarCartao : () => {}}
        className={`${verifyError() && "opacity-25"}`}
        loading={loading}
      >
        {invoice
          ? name_button
          : credit_card
          ? "Atualizar cartão"
          : "Cadastrar Cartão"}
      </ButtomSave>
      <PaymentStatus
        open={status_payment.open}
        icon={status_payment.icon}
        title={status_payment.title}
        legend={status_payment.legend}
      />
    </div>
  );
};

export default FormCreditCard;
